import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapFiParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapFiParameterCreateDto,
  SapFiParameterDto,
  SapFiParameterExcelDownloadDto,
  SapFiParameterUpdateDto,
} from '../proxy/controlling/dtos/sap-fi-parameter';
import { SAPFIPARAMETER_CONFIG, SAPFIPARAMETER_FIELDS } from './sap-fi-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-fi-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapFiParameterService, ConfirmationService],
  templateUrl: './sap-fi-parameter.html',
  styleUrl: './sap-fi-parameter.scss',
})
export class SapFiParameter extends BaseHierarchicalCrudComponent<
  SapFiParameterDto,
  SapFiParameterCreateDto,
  SapFiParameterUpdateDto,
  SapFiParameterExcelDownloadDto
> {
  service = inject(SapFiParameterService);
  config = SAPFIPARAMETER_CONFIG;
  fields = SAPFIPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapFiParameterDto): SapFiParameterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapFiParameter';
  }
}
